import type { GenerationStage } from "@ppt-agent/contracts";

export const WAITING_LINES: Record<GenerationStage, string[]> = {
  "brief": [
    "循着你的心意，落下第一笔",
    "字里行间，意图渐明",
    "让零散想法，凝成方向",
    "从一念微光，读懂你的远方",
    "静听每个字，寻找心中的回响",
    "将未尽之意，轻轻展开",
    "拾起你留下的线索，勾勒初章",
    "让心中所想，慢慢清晰",
    "于万千思绪中，认出你的主张",
    "一页未启，心意先行"
  ],
  "storyline": [
    "让故事，渐成脉络",
    "散落的灵感，正在连成篇章",
    "起承转合之间，寻一条清晰的线",
    "把每一处伏笔，安放在恰好的地方",
    "循着故事的河流，寻找下一道转弯",
    "让观点相遇，让篇章相连",
    "从开篇到落幕，铺一条有光的路",
    "为散落的珍珠，牵起一根细线",
    "让重要的那句话，抵达故事中央",
    "删繁就简，留下动人的次序"
  ],
  "visual_direction": [
    "为灵感，落下色彩",
    "在光影与留白间，寻找平衡",
    "让每一种表达，都有自己的气质",
    "借一抹颜色，说出心中所想",
    "让留白呼吸，让色彩相和",
    "为这一程故事，寻一身恰好的衣裳",
    "轻调明暗，等画面舒展",
    "在方寸之间，落定视觉的韵律",
    "让文字的温度，遇见画面的光",
    "收拢纷繁，为表达留下从容"
  ],
  "assets": [
    "让想象，渐渐显影",
    "把未曾谋面的画面，带到眼前",
    "光影正在汇聚，画面即将成形",
    "从一缕微光，描摹想象的轮廓",
    "让无形的念头，有一处可见的风景",
    "色彩交汇处，藏着新的可能",
    "借光为笔，替故事画一扇窗",
    "远处的画面，正在缓缓走近",
    "将想象铺开，等细节生长",
    "一笔一色，让心中的世界浮现"
  ],
  "slides": [
    "一页一页，让灵感有形",
    "文字与画面，正在彼此呼应",
    "让每一页，都接住你的表达",
    "把故事的节拍，落在翻页之间",
    "为每个观点，留一处恰好的位置",
    "从文字到画面，让意义自然生长",
    "让重要之处，站在光里",
    "页与页之间，故事正在舒展",
    "让细节各就其位，让表达自在发生",
    "此刻的灵感，正成为眼前的篇章"
  ],
  "preflight": [
    "细察毫厘，让表达从容",
    "在细节里，安放最后一份认真",
    "拂去微尘，让重点更加清晰",
    "让文字站稳，让画面舒展",
    "逐页细看，不负每一处用心",
    "在行距与留白间，再寻一分妥帖",
    "替每个细节，找到安稳的落点",
    "让多余的退后，让重要的显现",
    "从容再看一眼，把疏漏留在此刻",
    "让清晰与美感，在此相逢"
  ],
  "compile": [
    "将灵思，装订成篇",
    "让文字与图像，各就其位",
    "把此刻的想象，折成可以翻阅的页",
    "一页成形，一页有声",
    "将散落的光，收进同一册篇章",
    "为每个元素，留住可改写的余地",
    "让故事落地，让灵感可触",
    "从画面到文件，续上最后一段路",
    "把精心的编排，妥帖收好",
    "页角渐齐，篇章将立"
  ],
  "verify": [
    "再阅一遍，只为妥帖呈现",
    "把最后的细节，轻轻抚平",
    "沿着每一页，作最后一次巡礼",
    "让每一处连接，都通向正确的地方",
    "守住细节，也守住你的用心",
    "把未察觉的缺口，悄悄补齐",
    "再确认一遍，让交付多一分安心",
    "逐一照看，不让小处失约",
    "从第一页到末页，再走一遍",
    "在启幕之前，让一切安然就绪"
  ],
  "package": [
    "篇章将成，静候启幕",
    "把这一程灵感，交到你手中",
    "收好每一页，准备与你相见",
    "灵思已聚，只待轻轻展开",
    "将一路的光，装进这一份交付",
    "故事行至此处，等你翻开新章",
    "为这一程创作，系上最后的结",
    "把心意与细节，一并打包",
    "此刻收笔，下一刻启程",
    "让灵感抵达，让篇章开始"
  ]
};
